<mat-spinner class="mt-2 ml-4 absolute" *ngIf="!state.editorInitialized" [color]="'primary'" [diameter]="23">
</mat-spinner>

<div class="h-full function-editor-wrapper" [hidden]="!state.editorInitialized">
  <div
    class="monaco-editor-area"
    [ngStyle]="{ height: showDefaultInfo ? 'calc(100% - ' + errorInfoHeight + ')' : '100%' }"
  >
    <div
      y42MonacoEditor
      [options]="editorOptions"
      (editorInitialized)="initEditor($event)"
      id="editor"
      class="function-editor"
    ></div>
  </div>
  <button
    mat-button
    [mtxPopoverTriggerFor]="errorPopUp"
    [mtxPopoverTriggerOn]="'hover'"
    class="error-btn bad-background bad-text z-depth-1"
    *ngIf="!showDefaultInfo && state.monacoErrors && state.monacoErrors.length > 0"
  >
    {{ state.monacoErrors.length }}x Errors
  </button>
  <mtx-popover [closeOnPanelClick]="true" #errorPopUp="mtxPopover" [leaveDelay]="300" class="error-pop-up z-depth-1">
    <div style="width: 220px">
      <ul class="w-full pl-3">
        <li class="bad-text" *ngFor="let error of state.monacoErrors; trackBy: trackByIndex">{{ error?.message }}</li>
      </ul>
    </div>
  </mtx-popover>
  <div class="monaco-text-wrapper" [ngStyle]="{ height: errorInfoHeight }" *ngIf="showDefaultInfo">
    <div *ngIf="state.monacoErrors && state.monacoErrors.length > 0" class="monaco-error h-full">
      <ul class="w-full pl-3">
        <li class="bad-text" *ngFor="let error of state.monacoErrors; trackBy: trackByIndex">{{ error?.message }}</li>
      </ul>
    </div>
    <div class="monaco-instructions" *ngIf="showDefaultInfo">
      <table *ngIf="!state.monacoErrors || state.monacoErrors.length === 0" class="fs-07 text-gray-700">
        <tr>
          <td>Select a column:</td>
          <td class="text-left">
            <span class="font-medium">@</span>
          </td>
        </tr>
        <tr>
          <td>Auto formatting:</td>
          <td class="text-left">
            <span class="font-medium">CTRL / CMD + SHIFT + F</span>
          </td>
        </tr>
        <tr>
          <td>Get more info:</td>
          <td class="text-left">
            <span class="font-medium">CTRL / CMD + CLICK</span>
          </td>
        </tr>
        <tr>
          <td>Add comments:</td>
          <td class="text-left">
            <span class="font-medium">--</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
